import { Component } from '@angular/core';
import { NavController, NavParams, ViewController, ModalController } from 'ionic-angular';
import { GN } from '../../gn';
import { DIC } from '../dic';
import { ChatsPage } from './chats';

@Component({
  selector: 'page-messages',
  templateUrl: 'messages.html',
})
export class MessagesPage {
  loadingData: boolean = true
  messengers = []
  CountNewChats = 0
  addpoimap: any
  lat: any
  lon: any
  poiname: any
  cb: any


  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController, public gn: GN, public dic: DIC, public modalCtrl: ModalController) {
    this.addpoimap = navParams.get('addpoimap')

    console.log(this.addpoimap, 'this.addpoimap ')
    if (this.addpoimap == 1) {
      this.lat = navParams.get('lat')
      this.lon = navParams.get('lon')
      this.poiname = navParams.get('poiname')
    }
    // console.log(this.lat, this.lon, this.poiname, 'daj da vidime')
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad MessagesPage');
    this.loadData()
    var _that = this
    this.gn.reloadCHatFunction2 = function () {
      _that.loadData()
    }

  }
  ionViewDidLeave() {
    console.log('vleze vo ionViewDidLeave')
    this.gn.reloadCHatFunction2 = null
  }

  loadData() {
    this.loadingData = true
    var _that = this
    this.gn._Post('/api/gn/getUserss', { cid: this.gn.crypt(this.gn.user.ClientId), uid: this.gn.crypt(this.gn.user.UserId) }, function (_data) {
      console.log(_data, 'daj da vidam data')
      for (var i = 0; i < _data.length; i++) {
        var idx = -1
        for (var j = 0; j < _that.gn.ChatCountList.length; j++) {
          if (_that.gn.ChatCountList[j].fromuserid + '' == _data[i].id + '') {
            idx = j
          }
        }
        if (idx == -1) {
          _data[i].cnt = 0
        } else {
          _data[i].cnt = _that.gn.ChatCountList[idx].cnt
          _that.CountNewChats = _that.CountNewChats + 1
        }
        var viz = true
        for (var j = 0; j < _that.messengers.length; j++) {
          // if (_that.messengers[j].Visible)
          if (_that.messengers[j].id == _data[i].id) {
            viz = _that.messengers[j].Visible
          }
        }
        _data[i].Visible = viz

      }
      // console.log(_that.gn.Vehicles, 'this.gn.Vehicles')

      for (let c = 0; c < _that.gn.Vehicles.length; c++) {
        if (_that.gn.Vehicles[c].allowgarmin + '' == '1') {
          _data.push({ id: parseInt(_that.gn.Vehicles[c].vehicleid + ''), code: _that.gn.Vehicles[c].code, registration: _that.gn.Vehicles[c].registration, fullname: _that.gn.Vehicles[c].registration + ' (' + _that.gn.Vehicles[c].code + ')', cnt: 0, Visible: true, garmin: 1, direct: false })
        }
      }
      _that.messengers = _data
      // console.log(_that.messengers, 'daj da vidam messengers')
      // console.log(_that.messengers, 'daj mi _that.messengers')
      _that.loadingData = false
      // _that.resetSearch();
    })
  }

  text(msg) {
    console.log(msg, 'daj da vidam jas msg')
    var _that = this

    if (this.addpoimap == 1 && msg.driverid != -1 && msg.vehicleid != null) {
      let modal = this.modalCtrl.create(ChatsPage, {
        message: msg, addpoimap: this.addpoimap, lat: this.lat, lon: this.lon, poiname: this.poiname, cb: function () {
          // console.log(cb,'daj da vidime cb')
          _that.loadData()
        }
      },
        { cssClass: "modal-fullscreencomm" }
      );
      modal.present();

    }
    else if (msg.garmin == 1) {
      console.log('tuka vlagas li')
      let modal = this.modalCtrl.create(ChatsPage, {
        message: msg, cb: function () {
          // console.log(cb,'daj da vidime cb')
          _that.loadData()
        }
      },
        { cssClass: "modal-fullscreencomm" }
      );
      modal.present();

    }
    else {
      let modal = this.modalCtrl.create(ChatsPage, {
        message: msg, cb: function () {
          // console.log(forRoute, 'daj da go vidam parametaro')
          // if (forRoute == 1) {
          //   // var forRoute2 = 1
          //   debugger
          //   var _cb = _that.navParams.get('cb')
          //   _cb(forRoute)

          // var _cb = _that.navParams.get('cb')
          // console.log(_cb, 'daj da vidam cb')
          // _cb(forRoute2)
          // _that.navCtrl.pop()
          // }

          _that.loadData()

        }
      },
        { cssClass: "modal-fullscreencomm" }
      );
      modal.present();
    }
    // console.log(msg, 'daj da vidam msg')

  }


  dismissMessages() {
    this.viewCtrl.dismiss();
  }

  resetSearch() {
    for (var i = 0; i < this.messengers.length; i++) {
      this.messengers[i].Visible = true
    }
  }
  getItems(ev: any) {
    var val = ev.target.value;
    if (val == null) { val = '' }
    val = val.toLowerCase()
    this.searchClients(val);

  }


  searchClients(val) {
    if (val && val.trim() != '') {
      for (var i = 0; i < this.messengers.length; i++) {
        var idStr = this.messengers[i].id + '';
        if (idStr.indexOf(val) > -1) {
          this.messengers[i].Visible = true
        }
        else
          if (this.gn._latcyr(this.messengers[i].fullname.toLowerCase()).indexOf(val) > -1 || this.gn._cyrlat(this.messengers[i].fullname.toLowerCase()).indexOf(val) > -1) {
            this.messengers[i].Visible = true
          } else {
            this.messengers[i].Visible = false
          }
      }
    }
    else {
      this.resetSearch()
    }

  }

}



// WEBPACK FOOTER //
// ./src/pages/messages/messages.ts